import React from "react";
import moment from "moment/moment";
import {fetchDataEntity} from "../../../../api/entity-data";
import {PostToPbx} from "../../../../api/http-post";
import {ArrayToSelectOption, FilterArrayByKey, FormatMoneySouthAfrica2, UpcaseFirst} from "../../../../api/fn";
import ControllerSelectBox from "../../../../components/Common/ControllerInput/ControllerSelectBox";
import {Button, Col, DatePicker, Row} from "antd";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import LoadingProcessing from "../../../../components/Common/page/Common/LoadingProcessing";
import Connector from "../../../../redux/connector";
import TableDataView from "../../../../components/Common/tables/TableDataView";

const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
class ServiceLogsDeliveryVehiclePage  extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies: [],
            Projects: [],
            Periods: [],
            Data: null,
            Clients: [],
            Items: [],

            selectedCompany: "",
            selectedClient: "",
            selectedItem: "yes",
            selectedPeriod: "",
            selectedVehicle: "",
            selectedDriver: "",


            mode: "list",
            startDate: startOfMonth,
            endDate: moment().format("YYYY-MM-DD"),

            showPopup: false,
            selectedSite: "",
            selectedDate: "",
            busy: false,
        }

    }
    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Clients", "", "", this, undefined, "common/entity/SettingInvoiceServiceDebtors/list");
        await fetchDataEntity("Items", "", "", this, undefined, "common/entity/SettingInvoiceServiceItem/list");

    }
    handleChangeInput = async (key, value) => {
        this.setState({
            [key]: value,
        })
    }
    handleGetInputValue = (key) => {
        if (typeof this.state[key] === "undefined") {
            return ""
        }
        return this.state[key];
    }
    submitSearch = async () => {
        let state = this.state;
        if (state.selectedCompany === "") {
            alert("Please select company")
            return
        }
        if (state.selectedClient === "") {
            alert("Please select client")
            return
        }
        if (state.selectedItem === "") {
            alert("Please select item")
            return
        }
        let hub = {
            org: state.selectedCompany,
            client: state.selectedClient,
            item: state.selectedItem,
            startDate: state.startDate,
            endDate: state.endDate,
        }
        let endpoint = `/services/logs/vehicles`
        this.setState({busy: true,Data:null})
        await PostToPbx(hub, endpoint, async (output) => {
            let res = output.RESULT;
            this.setState({Data:res})
            this.setState({busy:false})
            console.log("(:)submitSearch logs result > ", res)
        })
    }

    renderCompanyBox = () => {
        let ls = [];
        ls = FilterArrayByKey(this.state.Companies, {})
        ls = ArrayToSelectOption(ls, ["CustomerNumber"], ["Name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Company"}
                name={"selectedCompany"}
            />
        )
    }
    renderClientBox = () => {
        let ls = [];
        for (let i in this.state.Clients) {
            let row = this.state.Clients[i];
            if (row.org !== this.state.selectedCompany) {
                continue
            }
            ls.push(row)
        }
        ls = FilterArrayByKey(ls, {})
        ls = ArrayToSelectOption(ls, ["name"], ["name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Client"}
                name={"selectedClient"}
            />
        )
    }
    renderItemBox = () => {
        let ls = [];
        for (let i in this.state.Items) {
            let row = this.state.Items[i];
            if (row.org !== this.state.selectedCompany) {
                continue
            }
            if (row.client !== this.state.selectedClient) {
                continue
            }
            ls.push(row)
        }
        ls = FilterArrayByKey(ls, {})
        ls = ArrayToSelectOption(ls, ["name"], ["name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Items"}
                name={"selectedItem"}
            />
        )
    }
    renderDashboardStatus=()=> {
        const toFix = (valIn) => {
            let str = valIn.toFixed(2)
            return parseFloat(str)
        }
        const rep = this.state.Data;
        /*
        "totalLogs": 1323,
  "totalService": 148496,
  "vehicles": 26
         */
        let ls=[
            {label:"Total Service",total:rep.totalService,currency:false,currValue:"",extraClass:""},
            {label:"Total Vehicles",total:rep.vehicles,currency:false,currValue:"",extraClass:""},
            {label:"Number of logs",total:rep.totalLogs,currency:false,currValue:"",extraClass:""},
            ]

        return(
            <Row gutter={18} className={"stRow borderTop"}>
            {ls.map(row=>{
                    return(
                        <Col span={4} className={"stRowCol"}>
                            <label className={"stRowLabel"}>{row.label}:</label>
                            <label className={`stRowTotal1 `} style={{...row.extraClass}}>
                                {row.currency?row.currValue:""} {row.currency?FormatMoneySouthAfrica2(row.total):row.total}
                            </label>
                        </Col>
                    )
                })}
            </Row>
        )
    }

    renderList = () => {
        let state = this.state;
        if (state.Data === null) {
            return(
                <div style={{}}>
                    <h3>No Data</h3>
                </div>
            )
        }
        //todo make list of vehicles
        let columns = [
            {id: 'vehicle', label: 'Re. Number', minWidth: 170, dataType: "string"},
            {id: 'totalService', label: 'Services', minWidth: 170, dataType: "string",align:"right" ,
                cellStyle:{textAlign:"right",justifyContent:"flex-end"},
                headerStyle: { textAlign: "right" },
            },
            {id: 'totalLogs', label: 'Logs', minWidth: 170, dataType: "string",align:"right",
                cellStyle:{textAlign:"right",justifyContent:"flex-end"},
                headerStyle: { textAlign: "right" },
            },
            ]

        let ls = state.Data.data;
        let data  = {columns: columns, data: ls}
        let otherFunctions=[
            /*https://materializecss.com/icons.html*/
            /*{
                icon:"phonelink_lock",
                isFreeAction:false,
                tooltip:"Suspend Client",
                myAction:this.activateClient,
                color:"primary"
            }*/
        ]

        return (
        <div style={{backgroundColor: "white", padding: 10,}}>
            <div>
                {this.renderDashboardStatus()}
            </div>

            <div style={{marginTop:40,}}>
            <Row gutter={18}>
                <Col span={24}>
                    <TableDataView
                        {...data}
                        tableTitle={UpcaseFirst(this.state.selectedItem) + " Records  (" + data.data.length + ") "}
                        otherFunctions={otherFunctions}
                        options={{
                            pageSize:20,
                        }}
                    />
                </Col>
            </Row>
            </div>

        </div>
        )
    }

    render() {

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Vehicle Service Logs</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <Row gutter={18}>
                            <Col span={12}>
                                {this.renderCompanyBox()}
                            </Col>
                            <Col span={12}>
                                {this.renderClientBox()}
                            </Col>
                        </Row>
                        <Row gutter={18} style={{marginTop: -30}}>
                            <Col span={12}>
                                {this.renderItemBox()}
                            </Col>
                            <Col span={12} style={styles.dateRow}>
                                <Col span={10} style={{marginTop: 30, height: 40}}>
                                    <DatePicker
                                        style={styles.datePickerBox}
                                        onChange={(date, dateString) => this.setState({startDate: dateString})}
                                        placeholder={"Start Date"}
                                    />
                                </Col>
                                <Col span={10} style={{marginTop: 30, height: 40}}>
                                    <DatePicker
                                        style={styles.datePickerBox}
                                        onChange={(date, dateString) => this.setState({endDate: dateString})}
                                        placeholder={"End Date"}
                                    />
                                </Col>
                                <Col span={4} style={{marginTop: 30, height: 40}}>
                                    <Button
                                        style={styles.datePickerBox}
                                        onClick={() => this.submitSearch()}
                                    >
                                        Search
                                    </Button>
                                </Col>

                            </Col>
                        </Row>
                        <div style={{
                            borderRadius: 5,
                            borderWidth: 1,
                            borderColor: "lightblue",
                            borderStyle: 'solid',
                            minHeight: 35,
                            padding: 5
                        }}>
                            {this.renderList()}

                        </div>

                    </div>

                    <LoadingProcessing open={this.state.busy} />
                </div>
            </Page>
        )
    }
}

export default Connector(ServiceLogsDeliveryVehiclePage);
const styles = {
    btnExport:{
        fontsize: 11,
        width: 75,
        marginTop:1,
        backgroundColor: "gray",
        color:"white"
    },
    boxFilterInner: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems:"center",
        paddingLeft:10,
        paddingRight:5,
        borderRight:"1px solid black",
        fontsize:14,
        fontWeight:"bold"
    },
    boxFilter: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems:"center"
    },
    dateRow: {
        display: "flex",
        flexDirection: "row"
    },
    datePickerBox: {
        height: 40,
        width: "100%"
    },
    row1Th: {
        border: "1px solid black",
    },
    rowForm: {
        marginBottom: 10,
        paddingBottom: 5,
        border: "0px solid lightgray",
        borderBottomWidth: 1,

    },
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}